import styled from 'styled-components';
import { breakpoint } from 'theme';

import DotsGrid from 'components/molecules/dots-grid/dots-grid';
import Typography from 'components/atoms/typography';

import { IsWhiteType } from './industries-slider';

export const StyledWrapper = styled.div<IsWhiteType>`
  padding-block: 36px;
  width: 100%;
  background-color: ${({ isWhite, theme }) =>
    isWhite ? `${theme.colors.white}` : `${theme.colors.complementary1}`};
  display: flex;
  justify-content: flex-end;
  padding-left: 16px;
  position: relative;
  height: 479px;
  overflow: hidden;
  background-color: ${({ specialColorBg }) => (specialColorBg ? '#ECEFF4' : '')};

  button[data-variant='slider']:disabled,
  button[data-variant='slider'] {
    color: ${({ specialColorBg }) => (specialColorBg ? '#000000' : '')};
    border-color: #bec0c5;
  }

  .swiper-scrollbar {
    background-color: ${({ specialColorBg }) => (specialColorBg ? '#BEC0C5 !important' : '')};
  }

  ${breakpoint.md} {
    padding: 72px 16px 64px 16px;
    height: 707px;
  }

  ${breakpoint.lg} {
    padding: 72px 0 64px 16px;
  }
`;

export const StyledContent = styled.div<IsWhiteType>`
  max-width: ${({ theme }) => theme.wrapper};
  width: 100%;
  margin: 0 auto;
  height: 100%;

  .swiper {
    display: flex;
    align-items: flex-end;
    position: relative;
    width: fill-available;

    &-scrollbar {
      background-color: ${({ theme }) => theme.colors.whiteAlpha40};
      height: 2px;
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      width: calc(100% - 16px);
      position: relative;
      left: 0;
      top: 0;
      order: 3;
      margin-right: auto;
      cursor: pointer;

      &-drag {
        cursor: pointer;
        height: 4px;
        background-color: ${({ isWhite, theme }) =>
          isWhite ? `${theme.colors.gray80}` : `${theme.colors.white}`};
        border-radius: 0;
      }
    }

    &-horizontal > &-scrollbar {
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }

    &-wrapper {
      order: 2;
      margin-block: ${({ theme }) => theme.gap.md};

      ${breakpoint.md} {
        margin-block: ${({ theme }) => theme.gap.lg};
      }
    }

    &-slide {
      &--disabled {
        opacity: 0.5;
        pointer-events: none;
      }
    }

    .slider-controls__button {
      align-items: flex-end;
      margin-top: ${({ theme }) => theme.gap.sm};

      ${breakpoint.md} {
        margin-top: ${({ theme }) => theme.gap.md};
      }
    }
  }
`;

export const StyledDots = styled(DotsGrid)<IsWhiteType>`
  svg {
    color: ${({ isWhite, theme }) =>
      isWhite ? `${theme.colors.complementary3}` : `${theme.colors.white}`};
  }

  top: 31px;
  left: 26px;
`;

export const StyledSubHeading = styled(Typography)`
  margin-bottom: ${({ theme }) => theme.gap.sm};
  padding-right: ${({ theme }) => theme.gap.sm};
`;

export const StyledTitle = styled(Typography)`
  max-width: 825px;
  padding-right: ${({ theme }) => theme.gap.sm};
`;
